import { Outlet, Navigate } from 'react-router';

export default function ({ isAuth, screenToNavigate }) {
  return !isAuth ? (
    <Outlet />
  ) : (
    <Navigate to={screenToNavigate} replace />
  );
}
